import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import './styles/tokens.css';
import './styles/ui.css';
import { appRoutes } from './App.js';
import { queryClient } from './lib/queryClient.js';
import { stripClientSecretFromLocation } from './lib/strip-client-secret.js';
import { takeJoinTokenFromLocation } from './lib/join-link.js';
import { installFlushOnHide } from './lib/telemetry.js';

// FIRST, before the router exists: a redirect-based payment method returns to return_url with
// Stripe's client secret in the query (Plans.tsx), and every request the app makes would send it
// as its Referer. Only that parameter goes; the router then starts from the clean address (#1732).
stripClientSecretFromLocation();
// And an invitation link's token, which travels in the `/join` fragment: kept in this tab,
// gone from the address before anything reads it (join links, 2026-11-02).
takeJoinTokenFromLocation();

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

// A DATA ROUTER, so a route can decide where it goes BEFORE it renders. nginx
// already serves index.html for every non-file path, so real URLs survive a
// refresh and a pasted link.
const router = createBrowserRouter(appRoutes);

// Product events queued in the last few seconds leave when the tab is hidden or closed.
installFlushOnHide();

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
